module.exports = __webpack_public_path__ + "static/img/new1.066750d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/new1.jpg
// module id = ShnT
// module chunks = 1